export default __webpack_public_path__ + "ce2fffc64b272841a43bab744553935c.png";